module.exports = __webpack_public_path__ + "static/media/3s_bis_01.6b112ce9.png";